<template>
  <div
    ref="container"
    class="outreach-contact-list__item"
    :style="{ 'max-width': `${maxWidth}` }"
  >
    <BaseEllipseContent
      :key="maxWidth"
      ref="ellipsis"
      :force-tooltip="forceTooltip"
    >
      <button
        v-if="clickable"
        class="outreach-contact-list__item-link tw:border-0 tw:bg-transparent tw:p-0"
        type="button"
      >
        <slot />
      </button>

      <div v-else>
        <slot />
      </div>

      <template #tooltip="{ isEllipsed }">
        <slot
          :is-ellipsed="isEllipsed"
          name="tooltip"
        />
      </template>
    </BaseEllipseContent>
    <span
      v-if="showComma"
      data-testid="comma"
    >
      ,
    </span>
  </div>
</template>

<script setup>
import { ref } from "vue";

import { BaseEllipseContent } from "shared/components/base";

const container = ref();
const ellipsis = ref();

defineProps({
  clickable: {
    type: Boolean,
  },
  forceTooltip: {
    type: Boolean,
  },
  showComma: {
    type: Boolean,
  },
  maxWidth: {
    type: String,
    default: "100%",
  },
});

defineExpose({
  clientWidth: () => container.value?.getBoundingClientRect()?.width || 0,
  isEllipsed: () => ellipsis.value?.isEllipsed || false,
});
</script>

<style lang="scss" scoped>
.outreach-contact-list__item {
  display: inline-flex;

  &-link {
    color: var(--s-color-blue-9);
    cursor: pointer;

    &:hover {
      color: var(--s-color-blue-5);
      text-decoration: underline;
    }
  }
}
</style>
